(function () {
  'use strict';

  // Intercept Dawn's slideTo to prevent it from switching away from slide 0
  document.addEventListener('DOMContentLoaded', function () {
    var checkSwiper = setInterval(function () {
      var mainEl = document.querySelector('.js-mainSlider');
      if (mainEl && mainEl.swiper) {
        clearInterval(checkSwiper);
        var swiper = mainEl.swiper;
        var origSlideTo = swiper.slideTo.bind(swiper);
        swiper.slideTo = function (index, speed, runCallbacks) {
          // Allow only slide 0, block Dawn from switching to featured media slide
          if (index === 0) {
            return origSlideTo(index, speed, runCallbacks);
          }
          console.log('[SSX] blocked slideTo', index);
          return;
        };
      }
    }, 100);
  });

  var SSX = {
    _debounceTimer: null,
    _isFetching: false,
    _sectionId: null,
    _productHandle: null,
    _lastVariantId: null,
    _lockObserver: null,
    _releaseTimer: null,

    init: function () {
      var section = document.querySelector('[data-ssx-section]');
      if (!section) return;

      this._sectionId = section.dataset.ssxSection;
      this._productHandle = section.dataset.ssxHandle;

      if (!this._sectionId || !this._productHandle) return;

      var idInput = this._getVariantInput();
      if (idInput) this._lastVariantId = idInput.value;

      this._initSwiper();
      this._bindVariantChanges();
    },

    // Find the hidden variant ID input field
    _getVariantInput: function () {
      return (
        document.querySelector('input.product-variant-id') ||
        document.querySelector('#product-form-' + this._sectionId + ' input[name="id"]') ||
        document.querySelector('form[id^="product-form"] input[name="id"]')
      );
    },

    // Listen for variant changes via multiple methods for maximum compatibility
    _bindVariantChanges: function () {
      var self = this;

      // Method 1: MutationObserver on hidden input value attribute
      var idInput = this._getVariantInput();
      if (idInput) {
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'value') {
              var newVal = idInput.getAttribute('value');
              if (newVal && newVal !== self._lastVariantId) {
                self._lastVariantId = newVal;
                self._scheduleRerender(newVal);
              }
            }
          });
        });
        observer.observe(idInput, { attributes: true });
      }

      // Method 2: Change event on form input[name="id"]
      document.addEventListener('change', function (e) {
        var target = e.target;
        if (!target) return;
        if (target.name === 'id') {
          var variantId = target.value;
          if (variantId && variantId !== self._lastVariantId) {
            self._lastVariantId = variantId;
            self._scheduleRerender(variantId);
          }
        }
      });

      // Method 3: Dawn's custom variant:change event
      document.addEventListener('variant:change', function (e) {
        if (e.detail && e.detail.variant && e.detail.variant.id) {
          var variantId = String(e.detail.variant.id);
          if (variantId !== self._lastVariantId) {
            self._lastVariantId = variantId;
            self._scheduleRerender(variantId);
          }
        }
      });

      // Method 4: Polling fallback every 300ms
      setInterval(function () {
        var input = self._getVariantInput();
        if (!input) return;
        var currentVal = input.value;
        if (currentVal && currentVal !== self._lastVariantId) {
          self._lastVariantId = currentVal;
          self._scheduleRerender(currentVal);
        }
      }, 300);
    },

    // Debounce rerender to avoid multiple rapid calls
    _scheduleRerender: function (variantId) {
      var self = this;
      clearTimeout(this._debounceTimer);
      this._debounceTimer = setTimeout(function () {
        self._rerender(variantId);
      }, 150);
    },

    // Lock both media and info wrapper heights to prevent layout shift
    _lockHeight: function () {
      console.log('[SSX] _lockHeight called at', performance.now().toFixed(0) + 'ms');

      var infoWrapper = document.querySelector('.product__info-wrapper');
      var mediaWrapper = document.querySelector('.product__media-wrapper');
      if (!infoWrapper) return;

      var hInfo = infoWrapper.offsetHeight;
      var hMedia = mediaWrapper ? mediaWrapper.offsetHeight : 0;
      if (hInfo <= 0) return;

      console.log('[SSX] locking info:', hInfo + 'px', '| media:', hMedia + 'px');

      var parent = infoWrapper.parentElement;

      // Lock both columns
      infoWrapper.style.minHeight = hInfo + 'px';
      infoWrapper.style.overflow = 'hidden';
      if (mediaWrapper && hMedia > 0) {
        mediaWrapper.style.minHeight = hMedia + 'px';
        mediaWrapper.style.overflow = 'hidden';
      }

      // Disconnect any existing observer
      if (this._lockObserver) {
        this._lockObserver.disconnect();
        this._lockObserver = null;
      }

      // Re-apply lock if Dawn replaces inner elements
      this._lockObserver = new MutationObserver(function () {
        var elInfo = parent.querySelector('.product__info-wrapper');
        var elMedia = parent.querySelector('.product__media-wrapper');
        if (elInfo) {
          elInfo.style.minHeight = hInfo + 'px';
          elInfo.style.overflow = 'hidden';
        }
        if (elMedia && hMedia > 0) {
          elMedia.style.minHeight = hMedia + 'px';
          elMedia.style.overflow = 'hidden';
        }
      });
      this._lockObserver.observe(parent, { childList: true, subtree: true });
    },

    // Disconnect all observers and release height locks on both columns
    _doRelease: function (settleObserver) {
      console.log('[SSX] _doRelease called at', performance.now().toFixed(0) + 'ms');

      if (settleObserver) settleObserver.disconnect();
      if (this._lockObserver) {
        this._lockObserver.disconnect();
        this._lockObserver = null;
      }
      clearTimeout(this._releaseTimer);

      var elInfo = document.querySelector('.product__info-wrapper');
      var elMedia = document.querySelector('.product__media-wrapper');

      if (elInfo) {
        console.log('[SSX] releasing info, current height:', elInfo.offsetHeight);
        elInfo.style.minHeight = '';
        elInfo.style.overflow = '';
      }
      if (elMedia) {
        console.log('[SSX] releasing media, current height:', elMedia.offsetHeight);
        elMedia.style.minHeight = '';
        elMedia.style.overflow = '';
      }
    },

    // Release height lock after relevant DOM changes settle
    // Ignores Swiper, Yotpo and other third-party mutations
    _releaseHeight: function () {
      var self = this;
      clearTimeout(this._releaseTimer);

      var infoWrapper = document.querySelector('.product__info-wrapper');
      var parent = infoWrapper ? infoWrapper.parentElement : null;

      var domSettleTimer = null;
      var hadRelevantMutation = false;

      var settleObserver = new MutationObserver(function (mutations) {
        // Ignore attribute changes (Swiper, animations) and third-party widgets
        var isRelevant = mutations.some(function (m) {
          // Skip all attribute mutations - these are Swiper/animation related
          if (m.type === 'attributes') return false;
          var cls = (m.target.className || '').toString();
          if (cls.indexOf('yotpo') !== -1) return false;
          if (cls.indexOf('shopify-app-block') !== -1) return false;
          if (cls.indexOf('shopify-block') !== -1) return false;
          if (cls.indexOf('swiper') !== -1) return false;
          return true;
        });
        if (!isRelevant) return;

        console.log('[SSX] relevant mutation detected');
        hadRelevantMutation = true;
        clearTimeout(domSettleTimer);
        // Wait 500ms after last relevant mutation before releasing
        domSettleTimer = setTimeout(function () {
          console.log('[SSX] settle observer triggered release');
          self._doRelease(settleObserver);
        }, 500);
      });

      if (parent) {
        settleObserver.observe(parent, { childList: true, subtree: true });
      }

      // If no relevant mutations after 600ms - release immediately
      this._releaseTimer = setTimeout(function () {
        if (!hadRelevantMutation) {
          console.log('[SSX] no relevant mutations - releasing immediately');
          self._doRelease(settleObserver);
        } else {
          // Hard fallback if relevant mutations keep coming
          console.log('[SSX] had relevant mutations - hard fallback in 5s');
          setTimeout(function () { self._doRelease(settleObserver); }, 5000);
        }
      }, 600);
    },

    // Fetch new gallery HTML from Sections Rendering API and replace current gallery
    _rerender: function (variantId) {
      if (this._isFetching) return;
      if (!variantId) return;

      var self = this;

      // Save scroll position before rerender to prevent page jump
      var scrollY = window.scrollY;

      var url = '/products/' + this._productHandle
        + '?variant=' + encodeURIComponent(variantId)
        + '&section_id=' + encodeURIComponent(this._sectionId);

      this._isFetching = true;

      // Lock both columns before fetch to prevent layout shift
      this._lockHeight();

      var galleryEl = document.getElementById('SSX-FilteredGallery-' + this._sectionId);
      if (galleryEl) {
        galleryEl.style.transition = 'none';
        galleryEl.style.opacity = '0.5';
      }

      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('SSX fetch error: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newGallery = doc.getElementById('SSX-FilteredGallery-' + self._sectionId);
          var currentGallery = document.getElementById('SSX-FilteredGallery-' + self._sectionId);

          if (!newGallery || !currentGallery) {
            console.warn('[SSX] Gallery element not found.');
            return;
          }

          // Destroy existing Swiper instances before replacing HTML
          self._destroySwiper();
          currentGallery.innerHTML = newGallery.innerHTML;

          // Restore scroll position after DOM update
          window.scrollTo(0, scrollY);

          // Wait two animation frames to ensure DOM is ready before reinitializing
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              self._initSwiper();
              window.scrollTo(0, scrollY);
            });
          });
        })
        .catch(function (err) {
          console.warn('[SSX] Gallery rerender error:', err);
          self._doRelease(null);
          var el = document.getElementById('SSX-FilteredGallery-' + self._sectionId);
          if (el) el.style.opacity = '1';
        })
        .finally(function () {
          self._isFetching = false;
        });
    },

    // Safely destroy both Swiper instances
    _destroySwiper: function () {
      if (window.productSwiperMain) {
        try { window.productSwiperMain.destroy(true, true); } catch (e) {}
        window.productSwiperMain = null;
      }
      if (window.productSwiperThumbs) {
        try { window.productSwiperThumbs.destroy(true, true); } catch (e) {}
        window.productSwiperThumbs = null;
      }
    },

    // Initialize Swiper for thumbnails and main gallery
    _initSwiper: function () {
      var self = this;
      var galleryEl = document.getElementById('SSX-FilteredGallery-' + this._sectionId);
      if (!galleryEl) return;

      var thumbsEl = galleryEl.querySelector('.js-thumbsSlider');
      var mainEl = galleryEl.querySelector('.js-mainSlider');

      if (!thumbsEl || !mainEl) {
        console.warn('[SSX] Swiper elements not found.');
        return;
      }

      // Wait for Swiper library to load
      if (typeof Swiper === 'undefined') {
        setTimeout(function () { self._initSwiper(); }, 200);
        return;
      }

      // Thumbnails slider - vertical
      var swiperThumbs = new Swiper(thumbsEl, {
        loop: false,
        spaceBetween: 8,
        slidesPerView: 'auto',
        freeMode: true,
        direction: 'vertical',
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
      });

      // Main gallery slider
      var swiperMain = new Swiper(mainEl, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: true,
        resistanceRatio: 0,
        observer: true,
        observeParents: true,
        scrollbar: false,
        thumbs: { swiper: swiperThumbs },
        on: {
          init: function () {
            // Hide scrollbar if present
            var sb = mainEl.querySelector('.swiper-scrollbar');
            if (sb) sb.style.display = 'none';
            this.update();
          }
        }
      });

      window.productSwiperMain = swiperMain;
      window.productSwiperThumbs = swiperThumbs;

      // Hide gallery immediately to prevent flash of wrong slide
      galleryEl.style.opacity = '0';

      swiperMain.slideTo(0, 0);
      swiperThumbs.slideTo(0, 0);

      // Show gallery after Dawn has finished its own slide switching
      setTimeout(function () {
        swiperMain.slideTo(0, 0);
        swiperThumbs.slideTo(0, 0);
        galleryEl.style.transition = 'opacity 0.3s ease';
        galleryEl.style.opacity = '1';

        // Start watching for DOM to settle then release height lock
        self._releaseHeight();
      }, 500);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { SSX.init(); });
  } else {
    SSX.init();
  }

})();